var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
var USE_LIST_EXTERNAL_MATCHES_BY_TEAM_ID = "useListExternalMatchesByTeamId";
var USE_LIST_EXTERNAL_MATCHES_BY_PLAYER_ID = "useListExternalMatchesByPlayerId";
var USE_LIST_OPPONENT_TEAMS = "useListOpponentTeams";
var USE_RETRIEVE_EXTERNAL_MATCH = "useRetrieveExternalMatch";
export var useRetrieveExternalMatch = function (_a) {
    var id = _a.id, enabled = _a.enabled;
    return useQuery({
        queryKey: [USE_RETRIEVE_EXTERNAL_MATCH, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id)
                            throw new Error("External Match ID is not defined!");
                        return [4 /*yield*/, api.get("/external-matches/".concat(id, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        cacheTime: STALE_TIME,
        staleTime: CACHE_TIME,
        enabled: !!id && enabled,
    });
};
export var useUpdateExternalMatch = function (_a) {
    var id = _a.id, team = _a.team, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!id) {
                    throw new Error("External Match ID is not defined!");
                }
                return [2 /*return*/, api.put("/external-matches/".concat(id, "/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            var _a;
            if (team === undefined) {
                throw new Error("Team must be defined!");
            }
            queryClient.invalidateQueries([
                USE_LIST_EXTERNAL_MATCHES_BY_TEAM_ID,
                team.id,
            ]);
            (_a = team.players) === null || _a === void 0 ? void 0 : _a.forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_EXTERNAL_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([USE_RETRIEVE_EXTERNAL_MATCH, id]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useListOpponentTeams = function () {
    return useQuery({
        queryKey: [USE_LIST_OPPONENT_TEAMS],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/opponent-teams/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        cacheTime: 1000 * 60,
        staleTime: 1000 * 60,
    });
};
export var useCreateExternalMatch = function (_a) {
    var team = _a.team, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/external-matches/", data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            var _a;
            if (team === undefined) {
                throw new Error("Team must be defined!");
            }
            queryClient.invalidateQueries([
                USE_LIST_EXTERNAL_MATCHES_BY_TEAM_ID,
                team.id,
            ]);
            (_a = team.players) === null || _a === void 0 ? void 0 : _a.forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_EXTERNAL_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useDeleteExternalMatch = function (_a) {
    var externalMatch = _a.externalMatch, team = _a.team, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!externalMatch) {
                    throw new Error("ExternalMatch is undefined");
                }
                return [2 /*return*/, api.delete("/external-matches/".concat(externalMatch.id, "/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            var _a;
            queryClient.invalidateQueries([
                USE_LIST_EXTERNAL_MATCHES_BY_TEAM_ID,
                externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team,
            ]);
            (_a = team === null || team === void 0 ? void 0 : team.players) === null || _a === void 0 ? void 0 : _a.forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_EXTERNAL_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.removeQueries([
                USE_RETRIEVE_EXTERNAL_MATCH,
                externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.id,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useUpdateExternalMatchResult = function (externalMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!(externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.externalMatchResult)) {
                    throw new Error("External match result not found!");
                }
                return [2 /*return*/, api.put("/external-match-results/".concat(externalMatch.externalMatchResult.id, "/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([
                USE_LIST_EXTERNAL_MATCHES_BY_TEAM_ID,
                externalMatch.team,
            ]);
            __spreadArray([], __read((externalMatch.players || [])), false).forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_EXTERNAL_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([
                USE_RETRIEVE_EXTERNAL_MATCH,
                externalMatch.id,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useCreateExternalMatchResult = function (externalMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/external-match-results/", data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([
                USE_LIST_EXTERNAL_MATCHES_BY_TEAM_ID,
                externalMatch.team,
            ]);
            __spreadArray([], __read((externalMatch.players || [])), false).forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_EXTERNAL_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([
                USE_RETRIEVE_EXTERNAL_MATCH,
                externalMatch.id,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useBulkUpdatePlayerExternalMatchStats = function (externalMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/bulk/player-external-match-stats/update/", {
                        updates: data,
                    })];
            });
        }); },
        onMutate: onMutate,
        onError: onError,
        onSuccess: function (data) {
            queryClient.invalidateQueries([
                USE_LIST_EXTERNAL_MATCHES_BY_TEAM_ID,
                externalMatch.team,
            ]);
            __spreadArray([], __read((externalMatch.players || [])), false).forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_EXTERNAL_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([
                USE_RETRIEVE_EXTERNAL_MATCH,
                externalMatch.id,
            ]);
            onSuccess(data);
        },
    });
};
export var useSubmitExternalMatchStats = function (externalMatch) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!(externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.id)) {
                    throw new Error("External match must be defined!");
                }
                return [2 /*return*/, api.post("/external-matches/".concat(externalMatch.id, "/submit-stats/"), data)];
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries([
                USE_LIST_EXTERNAL_MATCHES_BY_TEAM_ID,
                externalMatch.team,
            ]);
            __spreadArray([], __read((externalMatch.players || [])), false).forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_EXTERNAL_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([
                USE_RETRIEVE_EXTERNAL_MATCH,
                externalMatch.id,
            ]);
        },
    });
};
